import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  body: {
    lineHeight: '24px',
    fontSize: '16px',
    paddingTop: '32px'
  }
}));

const PromptModal = () => {
  const classes = useStyles();
  const { t } = useTranslation(['settings']);

  return (
    <>
      <Typography variant="h2">{t('integrations.are you sure you want to delete the API key')}</Typography>
      <Typography classes={{ root: classes.body }} variant="body1">
        {t('integrations.please note that once deactivated, it cannot be reinstated')}
      </Typography>
    </>
  );
};

export default PromptModal;
